import React from "react";
import { Wrapper, Copy } from "app/NativeComponents/common";
import { IconButton } from "app/NativeComponents/snippets";
import ReactDOM from "react-dom";
import { connect } from "react-redux";

export const PhoneBadge = ({
    phone_count = 0,
    dialable_phone_count = 0,
    scrub_dnc = false,
    showTooltip = false,
    onTooltipEnter,
    onTooltipLeave,
    anchorRect,
    dark_mode = null
}) => {

    const optimisticScrub = globalThis.__SCRUB_DNC_OPTIMISTIC__;

    const effectiveScrubDNC =
        optimisticScrub !== undefined
            ? optimisticScrub
            : scrub_dnc;

    const displayPhoneCount = effectiveScrubDNC
        ? dialable_phone_count ?? 0
        : phone_count ?? 0;

    const isDark = dark_mode === "dark_mode";

    const borderColor = isDark
        ? "rgba(71, 85, 105, 0.6)"
        : "rgba(72, 189, 252, 0.259)";

    const bgColor = isDark
        ? "rgba(15, 23, 42, 0.4)"
        : "rgba(184, 227, 255, 0.259)";

    const textColor = isDark
        ? "#F5F5F5"
        : "inherit";

    const tooltip =
        showTooltip && anchorRect
            ? ReactDOM.createPortal(
                <div
                    style={{
                        position: "fixed",
                        top: anchorRect.top - 26,
                        left: anchorRect.left + anchorRect.width / 2,
                        transform: "translateX(-50%)",
                        background: isDark
                            ? "rgba(15,23,42,0.95)"
                            : "rgba(0,0,0,0.7)",
                        color: "white",
                        padding: "6px 10px",
                        borderRadius: 6,
                        fontSize: 12,
                        lineHeight: "12px",
                        whiteSpace: "nowrap",
                        zIndex: 999999,
                    }}
                >
                    DNC numbers hidden
                </div>,
                document.body
            )
            : null;

    return (
        <>
            <span
                style={{
                    position: "relative",
                    border: `1px solid ${borderColor}`,
                    backgroundColor: bgColor,
                    color: textColor,
                    padding: "6px 8px",
                    fontSize: 14,
                    borderRadius: 8,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6
                }}
            >

                {effectiveScrubDNC && (
                    <span
                        onMouseEnter={onTooltipEnter}
                        onMouseLeave={onTooltipLeave}
                        style={{
                            position: "absolute",
                            top: -8,
                            right: -8
                        }}
                    >
                        <IconButton
                            button_type="small"
                            icon="lock"
                            backgroundColor={isDark ? "#1e293b" : "#e0f2fe"}
                            icon_color={isDark ? "#7dd3fc" : "#0284c7"}
                            hover_color={isDark ? "#334155" : "#bae6fd"}
                            disabled={true}
                            style={{
                                width: 22,
                                height: 22,
                                borderRadius: 11,
                                margin: 0
                            }}
                        />
                    </span>
                )}

                <span style={{ display: "flex", alignItems: "center" }}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        color="currentColor"
                    >
                        <path
                            d="M9.1585 5.71217L8.75584 4.80619C8.49256 4.21382 8.36092 3.91762 8.16405 3.69095C7.91732 3.40688 7.59571 3.19788 7.23592 3.08779C6.94883 2.99994 6.6247 2.99994 5.97645 2.99994C5.02815 2.99994 4.554 2.99994 4.15597 3.18223C3.68711 3.39696 3.26368 3.86322 3.09497 4.35054C2.95175 4.76423 2.99278 5.18937 3.07482 6.03964C3.94815 15.0901 8.91006 20.052 17.9605 20.9254C18.8108 21.0074 19.236 21.0484 19.6496 20.9052C20.137 20.7365 20.6032 20.3131 20.818 19.8442C21.0002 19.4462 21.0002 18.972 21.0002 18.0237C21.0002 17.3755 21.0002 17.0514 20.9124 16.7643C20.8023 16.4045 20.5933 16.0829 20.3092 15.8361C20.0826 15.6393 19.7864 15.5076 19.194 15.2443L18.288 14.8417C17.6465 14.5566 17.3257 14.414 16.9998 14.383C16.6878 14.3533 16.3733 14.3971 16.0813 14.5108C15.7762 14.6296 15.5066 14.8543 14.9672 15.3038C14.4304 15.7511 14.162 15.9748 13.834 16.0946C13.5432 16.2009 13.1588 16.2402 12.8526 16.1951C12.5071 16.1442 12.2426 16.0028 11.7135 15.7201C10.0675 14.8404 9.15977 13.9327 8.28011 12.2867C7.99738 11.7576 7.85602 11.4931 7.80511 11.1476C7.75998 10.8414 7.79932 10.457 7.90554 10.1662C8.02536 9.83822 8.24905 9.5698 8.69643 9.03294C9.14586 8.49362 9.37058 8.22396 9.48939 7.91885C9.60309 7.62688 9.64686 7.31234 9.61719 7.00042C9.58618 6.67446 9.44362 6.3537 9.1585 5.71217Z"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeWidth="1.5"
                        />
                    </svg>
                </span>

                <span style={{ fontWeight: 900, lineHeight: "12px" }}>
                    {displayPhoneCount}
                </span>

                <span style={{ fontSize: 12, lineHeight: "12px" }}>
                    Phone{displayPhoneCount !== 1 ? "s" : ""}
                </span>

            </span>

            {tooltip}
        </>
    );
};

export const EmailBadge = ({
    emailCount = 0,
    dark_mode = null
}) => {

    const isDark = dark_mode === "dark_mode";
    const textColor = isDark ? "#c7d1fc" : "#372aac";

    return (
        <span
            style={{
                border: "1px solid rgba(94, 129, 255, 0.29)",
                backgroundColor: "rgba(149, 174, 255, 0.25)",
                color: textColor,
                padding: "6px 8px",
                fontSize: 14,
                borderRadius: 8,
                display: "inline-flex",
                alignItems: "center",
                gap: 6
            }}
        >

            <span style={{ display: "flex", alignItems: "center" }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    color="currentColor"
                >
                    <path
                        d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6"
                        stroke="currentColor"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                    <path
                        d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"
                        stroke="currentColor"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                </svg>
            </span>

            <span style={{ fontWeight: 900, lineHeight: "12px" }}>
                {emailCount}
            </span>

            <span style={{ fontSize: 12, lineHeight: "12px" }}>
                Email{emailCount !== 1 ? "s" : ""}
            </span>

        </span>
    );
};

class ContactabilityColumnItem extends React.Component {

    state = {
        showScrubTooltip: false,
        tooltipAnchorRect: null
    };

    handleTooltipEnter = (e) => {
        this.setState({
            showScrubTooltip: true,
            tooltipAnchorRect: e.currentTarget.getBoundingClientRect()
        });
    };

    handleTooltipLeave = () => {
        this.setState({
            showScrubTooltip: false,
            tooltipAnchorRect: null
        });
    };

    renderContactability() {
        const { property, user, dark_mode } = this.props;

        const contactability = property?.contactability;
        if (!contactability) return <Copy>--</Copy>;

        const scrub_dnc =
            user?.workspace_settings?.should_scrub_dnc_phone_numbers
                ? true
                : user?.user_settings?.dialer_settings?.scrub_dnc ?? true;

        const totalPhones = contactability.phone_count || 0;
        const totalEmails = contactability.email_count || 0;

        if (!totalPhones && !totalEmails) return <Copy>--</Copy>;

        return (
            <div style={{ display: "flex", gap: 6 }}>
                {totalPhones > 0 && (
                    <PhoneBadge
                        phone_count={totalPhones}
                        dialable_phone_count={contactability.dialable_phone_count}
                        scrub_dnc={scrub_dnc}
                        showTooltip={this.state.showScrubTooltip}
                        onTooltipEnter={this.handleTooltipEnter}
                        onTooltipLeave={this.handleTooltipLeave}
                        anchorRect={this.state.tooltipAnchorRect}
                        dark_mode={dark_mode}
                    />
                )}

                {totalEmails > 0 && (
                    <EmailBadge
                        emailCount={totalEmails}
                        dark_mode={dark_mode}
                    />
                )}
            </div>
        );
    }

    render() {
        const { row_height } = this.props;

        return (
            <Wrapper
                className="deal-hover-preview"
                style={{
                    padding: 10,
                    height: row_height,
                    position: "relative"
                }}
            >
                <Wrapper
                    style={{
                        flex: 1,
                        alignItems: "flex-start",
                        justifyContent: "center"
                    }}
                >
                    {this.renderContactability()}
                </Wrapper>
            </Wrapper>
        );
    }
}

const mapStateToProps = ({ settings }) => ({
    dark_mode: settings?.dark_mode,
});

export default connect(mapStateToProps)(ContactabilityColumnItem);
